import React, { PropsWithChildren, ReactElement, useMemo } from 'react';
import { FlexboxGrid } from 'rsuite';
import LabelWithInfoIcon from '../../common/LabelWithInfoIcon';
import { PresentationFlexboxGridItem } from '../../layout/PresentationLayout';

interface BucketItemProps {
  label: string;
  dark?: boolean;
  description?: string;
}

export const BucketItem = ({
  dark,
  label,
  description,
  children,
}: PropsWithChildren<BucketItemProps>): ReactElement => {
  const gridStyles = useMemo(() => {
    const styles = {
      padding: '6px 8px',
      minHeight: '55px',
    };
    if (dark) {
      return {
        ...styles,
        background: '#f5f5f5',
      };
    }
    return styles;
  }, [dark]);
  return (
    <FlexboxGrid
      style={gridStyles}
      justify="space-between"
      align="middle"
    >
      <PresentationFlexboxGridItem
        colspan={24}
        md={16}
        sm={12}
        xs={12}
        style={{ display: 'flex', gap: '8px' }}
      >
        <LabelWithInfoIcon
          label={label}
          infoText={description}
        />
      </PresentationFlexboxGridItem>
      <PresentationFlexboxGridItem
        colspan={24}
        md={8}
        sm={12}
        xs={12}
      >
        {children}
      </PresentationFlexboxGridItem>
    </FlexboxGrid>
  );
};
